<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="expert2.id">
                                        {{$t('expert2.titleFitment.view')}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-sm-7">
                                <div role="tablist">
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-obj
                                                 class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">Баҳолаш объекти маълумотлари</span>
                                            </div>
                                            <b-collapse id="expert2-obj" accordion="expert2-accordion" role="tabpanel"
                                                        class="mt-3">
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.owner')}}</label>
                                                            <div class="form-control">
                                                                <div v-if="expert2 && expert2.ownerClient">
                                                                    <strong>{{ expert2.ownerClient.fullName }}</strong>
                                                                    <span> - {{ expert2.ownerClient.firmName }} </span>
                                                                    <span class="badge badge-primary"
                                                                          v-if="expert2.ownerClient.type === 'Legal'"> Юридик шахс</span>
                                                                    <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.name')}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.evlGoalType")}}</label>
                                                            <div class="form-control">
                                                                <span v-if="expert2.evlGoalType">{{expert2.evlGoalType.typeName}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Банк ходими телефон рақами</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.bankPhone}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.province")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.province.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.region")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.region.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <label>{{$t("expert2.field.approaches")}}</label>
                                                                </div>
                                                                <div class="col-12">
                                                                    <div v-if="expert2.approachCost">
                                                                        {{$t("expert2.approach.expense")}}
                                                                    </div>
                                                                    <div v-if="expert2.approachIncome">
                                                                        {{$t("expert2.approach.income")}}
                                                                    </div>
                                                                    <div v-if="expert2.approachComparative">
                                                                        {{$t("expert2.approach.comparative")}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-doc
                                                 class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">{{$t('expert2.field.documents')}}</span>
                                            </div>
                                            <b-collapse id="expert2-doc" accordion="expert2-accordion" role="tabpanel"
                                                        class="scroll">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="section-header">
                                                            <h4>{{$t("expert2.field.docsToSubmit")}}</h4>
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="reportDropZone"
                                                                             label="expert2.field.docReport"
                                                                             :data="expert2.report"
                                                                             @change="(files) => {expert2.report = files}"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="texPassportDropZone"
                                                                             label="fitment.texPassport"
                                                                             :data="expert2.fitmentTexPassports"
                                                                             @change="(fitmentTexPassports) => {expert2.fitmentTexPassports = fitmentTexPassports}"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="fitmentPhotoDropZone"
                                                                             label="fitment.photos"
                                                                             :data="expert2.fitmentPictures"
                                                                             @change="(fitmentPictures) => {expert2.fitmentPictures = fitmentPictures}"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
<!--                                <div class="row mt-3">-->
<!--                                    <div class="col-12">-->
<!--                                        <div class="form-group">-->
<!--                                            <label>{{$t("report.field.agents")}} <span class="red">*</span></label>-->
<!--                                            <v-select v-model="expert2.agent" label="text"-->
<!--                                                      :options="agents"-->
<!--                                                      :filterable="false"-->
<!--                                                      @search="onUsersSearch"-->
<!--                                                      @search:focus="onUsersFocus">-->
<!--                                                <template slot="option" slot-scope="option" v-if="option">-->
<!--                                                    <div v-html="option.name"></div>-->
<!--                                                </template>-->
<!--                                                <template slot="selected-option"-->
<!--                                                          v-if="expert2.agent && expert2.agent.name">-->
<!--                                                    <div v-html="expert2.agent.name"-->
<!--                                                         @click="$eventBus.$emit('search:focus')"></div>-->
<!--                                                </template>-->
<!--                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>-->
<!--                                            </v-select>-->
<!--                                            <div class="red" v-if="$v.expert2.agent.id.$error">-->
<!--                                                {{$t("expert2.field.agent")}}-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn"
                                        v-if="canSave && hasPermission('E_BAHOLASH_EXPERT2_FITMENT_SAVE')"
                                        @click="onSave"
                                        :disabled="processing">
                                    {{$t("action.save")}}
                                </button>
<!--                                <button class="all-btn" @click="onPending" :disabled="processing"-->
<!--                                        v-if="isPending && hasPermission('E_BAHOLASH_EXPERT2_FITMENT_BIND_AGENT')">-->
<!--&lt;!&ndash;                                  <span>Тўлдирувчига бириктириш</span>&ndash;&gt;-->
<!--                                    {{$t("expert2.action.pending")}}-->
<!--                                </button>-->
                                <button class="all-btn delete-btn"
                                        v-if="hasPermission('E_BAHOLASH_EXPERT2_REJECT') && canReject"
                                        @click="onReject">
                                    <i class="fa fa-reply-all"></i>
                                    <span>Рад қилиш</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <expert2-reject-comment/>
    </div>
</template>

<script>

    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    // import {requiredUnless} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Expert2RejectComment from '@/components/Expert2RejectComment';

    export default {
        name: "EExpert2FitmentEditView",
        components: {
            BCollapse,
            PreviewDropZone,
            Expert2RejectComment
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                processing: false,
                loading: false,
                filter: initFilterModel(),
                expert2: {
                    id: null,
                    organizationName: '',
                    ownerClient: null,
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    name: '',
                    province: {},
                    region: {},
                    address: '',
                    evlGoalType: null,
                    clientReportNumber: '',
                    evlEstimatedDate: null,
                    report: [],
                    photos: [],
                    agent: {}
                },
                agents: []
            }
        },
        // validations() {
        //     return {
        //         expert2: {
        //             agent: {
        //                 id: {
        //                     required: requiredUnless(() => {
        //                         return !this.isPending
        //                     })
        //                 }
        //             }
        //         }
        //     }
        // },
        computed: {
            isPending() {
                return this.expert2.status === 'Pending';
            },
            canReject() {
                return this.hasPermission('E_BAHOLASH_EXPERT2_REJECT') && this.expert2.status === 'Pending';
            },
            canSave() {
                return this.expert2.status === 'Pending';
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                if (id && id > 0) {
                    this.loading = true;
                    this.$http.get(`/expert2/${id}`)
                        .then(res => {
                            vm.expert2 = res.data;
                            console.log(vm.expert2);
                            this.loading = false;
                        }, () => {
                            this.loading = false;
                        })
                }
            },
            onSave() {
                // this.$v.$touch();
                // if (this.$v.$invalid) {
                //     return;
                // }

                this.processing = true;

                this.$http.post('admin/expert2/save', this.expert2)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.expert2.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/e-appraisal/expert2/fitment/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onPending() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                this.$http.post('admin/e-appraisal/expert2/bind-agent', this.expert2)
                    .then(res => {
                        if (res.data && res.data.code === 'DENIED') {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.expert2.validate'),
                                type: 'error'
                            });
                        } else if (res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/expert2/fitment/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onReject() {
                this.$eventBus.$emit('Expert2RejectComment', this.expert2.id, false, "Expert2", true);
            },
            cancel() {
                this.$router.push('/e-appraisal/expert2/fitment/list')
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;

                this.filter.province = null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';

                this.filter.province = this.expert2.province ? this.expert2.province : null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .btn-expert2 {
        background-color: #87CB16;
        border: 1px solid #87CB16;
        color: #FFFFFF;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 5px;
        margin-top: 5px;
        cursor: pointer;
        text-align: center;
        line-height: normal;
        position: relative;
        transition: inherit;
        align-items: center;
        text-transform: uppercase;
    }

    .btn-expert2 span {
        color: #fff;
        font-size: 14px;
    }

    .scroll {
        max-height: 600px;
        width: auto;
        overflow: scroll;
    }

    .check-blog .form-check-label {
        text-transform: uppercase;
        font-size: 12px;
    }
</style>